import { classNames } from '@wix/answers-lib';
import * as React from 'react';
import { RenderHtml } from '../../utils';
export const Icon = props => {
    const className = classNames('article-icon-comp', 'icon', props.className, { 'has-color-override': !!props.color });
    const style = props.color && { '--var-color': props.color };
    return (React.createElement("span", { className: className, "aria-hidden": props.ariaHidden, style: style },
        React.createElement(RenderHtml, { html: props.icon, dangerouslyDisableSanitation: props.dangerouslyDisableSanitation })));
};
